var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdChart',{attrs:{"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }